
export enum PhpRoute { 
    HOME = 'HOME',
    PROFILE = 'PROFILE',
    LOGOUT = 'LOGOUT',
}

export enum KnowledgeBaseRoute {
    SWAPPING = '/how-to-trade-swap-shifts-in-the-shift-swapping-module/',
}